export function applyRumSamplingLimit(settings, maxRate = 5) {
  if (settings?.datadog_js?.session_sample_rate > maxRate) {
    return {
      ...settings,
      datadog_js: {
        ...settings.datadog_js,
        session_sample_rate: maxRate,
      },
    }
  }
  return settings
}
